module.exports = __webpack_public_path__ + "static/media/greenBingoBall.80c56b9f.png";